// TODO to mixins.ts (import from javascript fails, module loader?)
// TODO do not or do inherit properties (it currently does)
// TODO do not overwrite methods in base class (so text.size() must not be overwritten by Strokable.size())
export const applyMixins = (derivedConstructor: any, baseConstructors: any[]) => {
    for (const baseConstructor of baseConstructors) {
        const properties = Object.getOwnPropertyNames(baseConstructor.prototype)
        for (const name of properties) {
            const value = Object.getOwnPropertyDescriptor(baseConstructor.prototype, name)
            Object.defineProperty(derivedConstructor.prototype, name, value!)
            //            console.log({ baseConstructor, name, value })
        }
    }
}
